// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"442":"27f69d63","508":"27f69d63","548":"a57ca770","808":"27f69d63","826":"dfb99607","893":"80279192"}[chunkId] + ".chunk.css";
};